import _Promise from 'babel-runtime/core-js/promise';
import 'babel-runtime/core-js/object/keys';
import 'babel-runtime/core-js/json/stringify';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import 'babel-runtime/helpers/toConsumableArray';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import { q as domReady, e as callback, r as asyncCallback, n as getter } from './chunks/chunk-d93006cb.js';
import _Object$create from 'babel-runtime/core-js/object/create';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';

var _this = undefined;

var attach$$ = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(element) {
    var controllerAttempt, _ref4, _ref5, Controller;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            controllerAttempt = {};

            element._currentControllerAttempt = controllerAttempt;

            _context3.next = 4;
            return domReady;

          case 4:
            _context3.next = 6;
            return _Promise.all([element._preController(), globalScopedEval(element.getAttribute('controller'))]);

          case 6:
            _ref4 = _context3.sent;
            _ref5 = _slicedToArray(_ref4, 2);
            Controller = _ref5[1];


            if (Controller && !controllerAttempt.aborted) {
              element._controller = new Controller(element, globalScopedEval('(' + element.getAttribute('controller-options') + ')'));
            }
            element._postController();

          case 11:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function attach$$(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var _window = window,
    HTMLElement = _window.HTMLElement;

var globalScopedEval = eval;

var property = 'HTMLPdrAppElement';
var registeredStyle = {};

var basePrototype = {
  createdCallback: callback(create$$),
  attachedCallback: callback(attach$$),
  detachedCallback: callback(detach$$),
  attributeChangedCallback: callback(),

  _preController: asyncCallback(function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(element) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }() /* OVERRIDABLE */),
  _postController: asyncCallback(function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(element) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }() /* OVERRIDABLE */),
  _style: getter(_style$$)
};

var pdrApp = window[property] = window[property] || document.registerElement('pdr-app', {
  prototype: _Object$create(HTMLElement.prototype, basePrototype)
});

var prototype = window[property].prototype;

function create$$(element) {
  registerStyle(element);
}

function detach$$(element) {
  element._currentControllerAttempt && (element._currentControllerAttempt.aborted = true);
  element._currentControllerAttempt = null;

  element._controller && element._controller.destroy && element._controller.destroy();
  element._controller = null;
}

function _style$$(element) {
  var TAG = element.tagName;
  return '\n    ' + TAG + ' {\n      display: block;\n    }\n  ';
}

function registerStyle(element) {
  var TAG = element.tagName;
  if (registeredStyle[TAG]) {
    return;
  }
  registeredStyle[TAG] = true;
  var style = element._style;
  if (style) {
    var styleElement = document.createElement('style');
    styleElement.textContent = style;
    document.head.appendChild(styleElement);
  }
}

export default pdrApp;
export { basePrototype, prototype };
